import {

    CORE_LOAD_ALL_DEPARTMENT_SUCCESS,
    CORE_LOAD_ALL_DEPARTMENT_REQUEST,

    CORE_LOAD_SEARCH_DEPARTMENT_SUCCESS,
    CORE_LOAD_SEARCH_DEPARTMENT_REQUEST,

    CORE_LOAD_DEPARTMENT_SUCCESS,
    CORE_LOAD_DEPARTMENT_REQUEST,

    // CORE_DELETE_DEPARTMENT_SUCCESS,
    // CORE_DELETE_DEPARTMENT_REQUEST,
} from '../../types'

const initialState = []
export default {
    department: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_DEPARTMENT_REQUEST:
                return initialState
            case CORE_LOAD_DEPARTMENT_SUCCESS:
                if (action.payload) {
                    return action.payload
                }
                else return {}
            default:
                return state
        }
    },
    departmentsList: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_ALL_DEPARTMENT_REQUEST:
            case CORE_LOAD_SEARCH_DEPARTMENT_REQUEST:
                return initialState
            case CORE_LOAD_ALL_DEPARTMENT_SUCCESS:
            case CORE_LOAD_SEARCH_DEPARTMENT_SUCCESS:
                if (action.payload) {
                    return action.payload
                }
                else return []
            default:
                return state
        }
    },

}


// WEBPACK FOOTER //
// ./src/features/department/reducer.js